import { BridgeDebugger } from "@amzn/geo-studio-web-sdk";

const BridgeDebuggerPage = () => <BridgeDebugger />;

export default BridgeDebuggerPage;
